import { render, staticRenderFns } from "./RELOcupacaoTurno.vue?vue&type=template&id=24ae28d2&"
import script from "./RELOcupacaoTurno.vue?vue&type=script&lang=js&"
export * from "./RELOcupacaoTurno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports